// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcpTableClass .p-datatable-wrapper {
    min-height: 53vh !important;
    max-height: 53vh !important;
}


/* .lcpTableClass .p-datatable-header {
    min-height: 6vh !important;
} */`, "",{"version":3,"sources":["webpack://./src/components/pages/LCP.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;;AAGA;;GAEG","sourcesContent":[".lcpTableClass .p-datatable-wrapper {\n    min-height: 53vh !important;\n    max-height: 53vh !important;\n}\n\n\n/* .lcpTableClass .p-datatable-header {\n    min-height: 6vh !important;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
